export const steps = [
  'Areas',
  'Ecosystem Components',
  'Deposition',
  'CL Type',
  'Species',
  'Outputs',
  'Results',
];

export const formOptions = {
  areaLayers: [
    'Class 1 Areas',
    'Federal Administrative Areas',
    'Tribal Lands',
    'Wilderness Areas',
    'Level 1-3 Ecoregions',
    'ECS',
  ],

  areas: {
    class1: [
      'Bering Sea Wilderness',
      'Bosque del Apache (Chupadera Unit) Wilderness',
      'Bosque del Apache (Indian Well Unit) Wilderness',
      'Bosque del Apache (Little San Pascual Unit) Wilderness',
      'Breton Wilderness',
      'Brigantine Wilderness',
      'Cape Romain Wilderness',
      'Chassahowitzka Wilderness',
      'Lostwood Wilderness',
      'Medicine Lake Wilderness',
      'Mingo Wilderness',
      'Moosehorn Wilderness (Baring Unit)',
      'Moosehorn Wilderness (Edmunds Unit)',
      'Okefenokee Wilderness',
      'Red Rock Lakes Wilderness',
      'Saint Marks Wilderness',
      'Salt Creek Wilderness',
      'Seney Wilderness',
      'Simeonof Wilderness',
      'Swanquarter Wilderness',
      'Tuxedni Wilderness',
      'UL Bend Wilderness',
      'Wichita Mountains (Charons Garden Unit) Wilderness',
      'Wichita Mountains (North Mountain Unit) Wilderness',
      'Wolf Island Wilderness',
      'Agua Tibia Wilderness',
      'Alpine Lakes Wilderness',
      'Anaconda Pintler Wilderness',
      'Ansel Adams Wilderness',
      'Bob Marshall Wilderness',
      'Boundary Waters Canoe Area Wilderness',
      'Bradwell Bay Wilderness',
      'Bridger Wilderness',
      'Cabinet Mountains Wilderness',
      'Caney Creek Wilderness',
      'Caribou Wilderness',
      'Chiricahua National Monument Wilderness',
      'Cohutta Wilderness',
      'Cucamonga Wilderness',
      'Desolation Wilderness',
      'Diamond Peak Wilderness',
      'Dolly Sods Wilderness',
      'Domeland Wilderness',
      'Eagle Cap Wilderness',
      'Eagles Nest Wilderness',
      'Emigrant Wilderness',
      'Fitzpatrick Wilderness',
      'Flat Tops Wilderness',
      'Galiuro Wilderness',
      'Gates of the Mountains Wilderness',
      'Gearhart Mountain Wilderness',
      'Gila Wilderness',
      'Glacier Peak Wilderness',
      'Goat Rocks Wilderness',
      'Great Gulf Wilderness',
      'Hells Canyon Wilderness',
      'Hercules-Glades Wilderness',
      'Hoover Wilderness',
      'James River Face Wilderness',
      'Jarbidge Wilderness',
      'John Muir Wilderness',
      'Joyce Kilmer-Slickrock Wilderness',
      'Kaiser Wilderness',
      'Kalmiopsis Wilderness',
      'La Garita Wilderness',
      'Linville Gorge Wilderness',
      'Lye Brook Wilderness',
      'Marble Mountain Wilderness',
      'Maroon Bells-Snowmass Wilderness',
      'Mazatzal Wilderness',
      'Mission Mountains Wilderness',
      'Mokelumne Wilderness',
      'Mount Adams Wilderness',
      'Mount Baldy Wilderness',
      'Mount Hood Wilderness',
      'Mount Jefferson Wilderness',
      'Mount Washington Wilderness',
      'Mount Zirkel Wilderness',
      'Mountain Lakes Wilderness',
      'North Absaroka Wilderness',
      'Otter Creek Wilderness',
      'Pasayten Wilderness',
      'Pecos Wilderness',
      'Pine Mountain Wilderness',
      'Presidential Range-Dry River Wilderness',
      'Rainbow Lake Wilderness',
      'Rawah Wilderness',
      'San Gabriel Wilderness',
      'San Gorgonio Wilderness',
      'San Jacinto Wilderness',
      'San Pedro Parks Wilderness',
      'San Rafael Wilderness',
      'Sawtooth Wilderness',
      'Scapegoat Wilderness',
      'Selway-Bitterroot Wilderness',
      'Shining Rock Wilderness',
      'Sierra Ancha Wilderness',
      'Sipsey Wilderness',
      'South Warner Wilderness',
      'Strawberry Mountain Wilderness',
      'Superstition Wilderness',
      'Sycamore Canyon Wilderness',
      'Teton Wilderness',
      'Thousand Lakes Wilderness',
      'Three Sisters Wilderness',
      'Upper Buffalo Wilderness',
      'Ventana Wilderness',
      'Washakie Wilderness',
      'Weminuche Wilderness',
      'West Elk Wilderness',
      'Wheeler Peak Wilderness',
      'White Mountain Wilderness',
      'Yolla Bolly-Middle Eel Wilderness',
      'Acadia NP',
      'Arches NP',
      'Badlands NP',
      'Bandelier NM',
      'Big Bend NP',
      'Black Canyon of the Gunnison NP',
      'Bryce Canyon NP',
      'Canyonlands NP',
      'Capitol Reef NP',
      'Carlsbad Caverns NP',
      'Chiricahua NM',
      'Crater Lake NP',
      'Craters of the Moon NM',
      'Denali NP & Pres',
      'Everglades NP',
      'Glacier NP',
      'Grand Canyon NP',
      'Great Sand Dunes NP & Pres',
      'Great Smoky Mountains NP',
      'Grand Teton NP',
      'Guadalupe Mountains NP',
      'Haleakala NP',
      'Hawaii Volcanoes NP',
      'Isle Royale NP',
      'Joshua Tree NP',
      'Sequoia / Kings Canyon NP',
      'Lava Beds NM',
      'Lassen Volcanic NP',
      'Mammoth Cave NP',
      'Mesa Verde NP',
      'Mount Rainier NP',
      'North Cascades NP',
      'Olympic NP',
      'Petrified Forest NP',
      'Pinnacles NM',
      'Point Reyes NS',
      'Redwood NP',
      'Rocky Mountain NP',
      'Saguaro NP',
      'Shenandoah NP',
      'Theodore Roosevelt NP',
      'Virgin Islands NP',
      'Voyageurs NP',
      'Wind Cave NP',
      'Yellowstone NP',
      'Yosemite NP',
      'Zion NP',
    ],
  },

  components: ['Aquatic', 'Lichens', 'Trees'],

  depositions: ['Nitrogen', 'Sulfur'],

  clTypes: {
    lichens: [
      'Total species richness CL',
      'Sensitive-species richness CL',
      'Forage — abundance CL',
      'Cyano — abundance CL',
      'Composite score CL',
    ],
    trees: ['Growth', 'Survival'],
  },

  species: {
    trees: [
      'Abies amabilis',
      'Abies balsamea',
      'Abies concolor',
      'Abies grandis',
      'Abies lasiocarpa',
      'Acer negundo',
      'Acer rubrum',
      'Acer saccharinum',
      'Acer saccharum',
      'Betula alleghaniensis',
      'Betula lenta',
      'Betula papyrifera',
      'Calocedrus decurrens',
      'Carpinus caroliniana',
      'Carya alba',
      'Carya cordiformis',
      'Carya glabra',
      'Carya ovata',
      'Carya texana',
      'Celtis laevigata',
      'Celtis occidentalis',
      'Fagus grandifolia',
      'Fraxinus americana',
      'Fraxinus nigra',
      'Fraxinus pennsylvanica',
      'Gleditsia triacanthos',
      'Juglans nigra',
      'Juniperus monosperma',
      'Juniperus occidentalis EXC: ',
      'Juniperus osteoseperma EXC: ',
      'Juniperus virginiana',
      'Larix laricina',
      'Larix occidentalis',
      'Liquidambar styraciflua',
      'Liriodendron tulipifera',
      'Lithocarpus densiforus',
      'Maclura pomifera',
      'Magnolia virginiana',
      'Nyssa aquatica',
      'Nyssa biflora',
      'Nyssa sylvatica',
      'Ostrya virginiana',
      'Oxydendrum arboreum',
      'Picea engelmannii',
      'Picea glauca',
      'Picea mariana',
      'Picea rubens',
      'Pinus banksiana',
      'Pinus contorta',
      'Pinus echinata',
      'Pinus edulis',
      'Pinus elliottii',
      'Pinus monophylla',
      'Pinus palustris',
      'Pinus ponderosa',
      'Pinus resinosa',
      'Pinus rigida',
      'Pinus strobus',
      'Pinus taeda',
      'Pinus virginiana',
      'Platanus occidentalis',
      'Populus balsamifera',
      'Populus grandidentata',
      'Populus tremuloides',
      'Prunus serotina',
      'Pseudotsuga menziesii',
      'Quercus alba',
      'Quercus chrysolepis',
      'Quercus coccinea',
      'Quercus ellipsoidalis',
      'Quercus falcata',
      'Quercus laurifolia',
      'Quercus macrocarpa',
      'Quercus muehlenbergii',
      'Quercus nigra',
      'Quercus phellos',
      'Quercus prinus',
      'Quercus rubra',
      'Quercus stellata',
      'Quercus velutina',
      'Robinia pseudoacacia',
      'Salix nigra',
      'Sassafras albidum',
      'Taxodium ascendens',
      'Taxodium distichum',
      'Thuja occidentalis',
      'Thuja plicata',
      'Tilia americana',
      'Tsuga canadensis',
      'Tsuga heterophylla',
      'Tsuga mertensiana',
      'Ulmus alata',
      'Ulmus americana',
      'Ulmus rubra',
    ],
  },

  outputs: ['Minimum', 'Median', '95 Percentile'],

  mapLayers: {
    base: [
      'None',
      'Google Terrain',
      'Google Hybrid',
      'Google Satellite',
      'Google Street',
      'Bing Hybrid',
      'Bing Satellite',
      'Bing Street',
      'USGS Topo',
      'State Outlines',
    ],
    abiotic: [
      'N Deposition (T-Dep)',
      'Aspect',
      'Depth to Bedrock',
      '% Clay in Soil',
      '% Coarse Sand',
      'Elevation',
      'Soil Permeability',
      'Soil pH',
      'Slope Gradient',
      'Precipitation (Annual)',
      'Precipitation (May-Sept)',
      'Temperature (Jan)',
      'Temperature (July)',
      'Temperature (May-Sept)',
    ],
  },
};
